import { render } from "./PatientIndex.vue?vue&type=template&id=55f6c523"
import script from "./PatientIndex.vue?vue&type=script&lang=js"
export * from "./PatientIndex.vue?vue&type=script&lang=js"

import "./PatientIndex.vue?vue&type=style&index=0&id=55f6c523&lang=css"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__